/**
 * AH – Hero Section  |  Nasalix Shopify Theme
 * File: assets/ah-hero-section.js
 *
 * Purpose: Shopify Theme Editor event awareness only.
 * No animations, no parallax, no effects — the design is static.
 *
 * Requires: jQuery (included in Shopify themes by default via
 *   {{ 'jquery.js' | asset_url | script_tag }} in theme.liquid,
 *   or Dawn's native deferred jQuery)
 */

(function ($) {
  'use strict';

  /* ── SHOPIFY THEME EDITOR ─────────────────────────────────
     section:select  — merchant clicked the section in editor
     section:deselect — merchant clicked away
     block:select    — merchant clicked a block (CTA button)
     section:load    — section reloaded after settings save
  ─────────────────────────────────────────────────────────── */

  function getSectionEl(sectionId) {
    return document.getElementById('ah-hero-' + sectionId);
  }

  document.addEventListener('shopify:section:load', function (e) {
    /* Re-query the DOM after a settings save reloads the section HTML */
    var el = getSectionEl(e.detail.sectionId);
    if (!el) return;
    /* Nothing to re-init for a static section — placeholder for future use */
  });

  document.addEventListener('shopify:block:select', function (e) {
    /* Optionally scroll to the CTA button being edited */
    var el = getSectionEl(e.detail.sectionId);
    if (!el) return;
    var $block = $(el).find('[data-block-id="' + e.detail.blockId + '"]');
    if ($block.length) {
      $block[0].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  });

})(jQuery);